export default "images/lateral risk field.png";